import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export default axiosInstance;

axiosInstance.interceptors.request.use(async (config) => {
  return {
    ...config,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "X-WPSL-PLATFORM": "app",
      ...config.headers,
    },
  };
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const requestURL = error.response?.config?.url;
    if (error.response?.status === 401 && !requestURL.includes("checkkeystatus")) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
